import { fetchFaqData, fetchFaqsData } from "./actions/fetchActions";
import {
  faqsReducer,
  faqReducer,
  createFaqReducer,
  updateFaqReducer,
  deleteFaqReducer,
} from "./reducers/fetchReducers";

const faqsReducers = {
  faqsGlobalStore: faqsReducer,
  faqGlobalStore: faqReducer,
  createFaqGlobalStore: createFaqReducer,
  updateFaqGlobalStore: updateFaqReducer,
  deleteFaqGlobalStore: deleteFaqReducer,
};

export { fetchFaqData, fetchFaqsData, faqsReducers };
